import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import HomePage from './Pages/HomePage';
import MailingListForm from './Pages/MailingListForm';
import Admin from './Pages/Admin';
import './App.css';

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route exact path="mailing-list" element={<MailingListForm />} />
          <Route exact path="home" element={<HomePage />} />
          <Route exact path="admin" element={<Admin />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
